import { Typography } from '@telus-uds/components-web';

export default function Error() {
  return (
    <Typography block variant={{ size: 'display2' }} heading="h2">
      401: Not Authorized!
    </Typography>
  );
}
